import { Button } from "../../shared/ui/Button";
import { useTranslation } from "react-i18next";

type Props = {
    action: () => void;
    isMobile: boolean;
};

export const AuthBtn = ({ action, isMobile }: Props) => {
    const { t } = useTranslation();

    return (
        <Button
            type={isMobile ? "mobile" : "secondary"}
            action={action}
            size="medium"
            text={t("login")}
        />
    );
};